// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-main__wrap {\n  flex: 1 1 auto;\n  max-width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.horizontal-container {\n  z-index: 1;\n}", ""]);
// Exports
module.exports = exports;
